var map = {
  "./cs.messages.tsx": [
    "47729",
    [
      72876
    ]
  ],
  "./en.messages.tsx": [
    "72208",
    [
      97523
    ]
  ],
  "./sl.messages.tsx": [
    "64236",
    [
      27039
    ]
  ],
  "./hu.messages.tsx": [
    "30216",
    [
      50515
    ]
  ],
  "./de.messages.tsx": [
    "32844",
    [
      94295
    ]
  ],
  "./it.messages.tsx": [
    "68274",
    [
      28305
    ]
  ],
  "./pl.messages.tsx": [
    "19763",
    [
      79298
    ]
  ],
  "./fr.messages.tsx": [
    "30775",
    [
      35518
    ]
  ],
  "./sk.messages.tsx": [
    "63033",
    [
      39780
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 32397;
module.exports = __rspack_async_context;
